var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout main-layout_fullpage"},[_c('div',{staticClass:"main-layout__controls"},[_c('tab-tags',{attrs:{"active":_vm.active},on:{"changeView":_vm.changeView}})],1),_c(_vm.active,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }